import { partNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPartNumber";
import { css } from "styled-components";

partNumberStyles.labelText = {
    size: 26,
    weight: "bold",
    css: css`
        margin-right: 15px;
    `,
};

partNumberStyles.valueText = {
    size: 26,
    weight: "bold",
    css: css`
        margin-bottom: 5px;
    `,
};
